<script module lang="ts">
  export interface Props {
    value: string | null | undefined;
    /** Scale of the color circle in em. */
    size?: number;
    /** Only the circle, without the value. */
    circleOnly?: boolean;
  }
</script>

<script lang="ts">
  import { CommonTexts } from '../../services/CommonTexts';
  const { value, size = 1, circleOnly = false }: Props = $props();

  const Formatted = $derived.by((): string | null => {
    const color = value?.trim();
    if (!color) return null;
    return color.startsWith('#') ? color : `#${color}`;
  });
  const IsValidColor = $derived(Boolean(Formatted && /^#(?:[\da-f]{3,4}|[\da-f]{6}|[\da-f]{8})$/i.test(Formatted)));
</script>

<span class="colorValue" style:--color-size={`${String(size)}em`} aria-label={Formatted ?? CommonTexts.NoColor}>
  {#if IsValidColor}
    <span class="colorCircle" style:background-color={Formatted ?? undefined} aria-hidden="true"></span>
  {/if}
  {#if !circleOnly}
    <span class="mono">{Formatted ?? '–'}</span>
  {/if}
</span>

<style lang="scss">
  .colorValue {
    display: inline-flex;
    align-items: center;
    gap: 0.4em;
    vertical-align: middle;
    white-space: nowrap;
  }

  .colorCircle {
    display: inline-block;
    flex: 0 0 var(--color-size, 1em);
    width: var(--color-size, 1em);
    height: var(--color-size, 1em);
    box-sizing: border-box;
    border: 1px solid var(--layout-border-color, currentColor);
    border-radius: 50%;
  }
</style>
